import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import Link from "../Link";

const propTypes = {
  tabs: PropTypes.array,
  onSelect: PropTypes.func,
  activeKey: PropTypes.string
};

const Rounded = ({ tabs, onSelect, activeKey }) => {
  return (
    <Tabs>
      {tabs.map((t, key) => (
        <Tab
          key={key}
          $active={t.slug === activeKey}
          onClick={() => onSelect(t.slug)}
        >
          {t.name}
        </Tab>
      ))}
    </Tabs>
  );
};

const Tab = styled(Link)`
  color: #000;
  border-radius: 2px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 5px 1.25rem;
  ${({ $active }) =>
    $active &&
    `
      font-weight: 600;
      background-color: #fff;
      box-shadow: 0px 0px 4px rgba(0, 25, 39, 0.16);
  `};
`;

const Tabs = styled.div`
  padding: 0.375rem;
  border-radius: 2px;
  display: inline-flex;
  justify-content: center;
  background-color: var(--bs-gray-10);
`;

Rounded.propTypes = propTypes;

export default Rounded;
